if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let form_id_3664 = document.querySelector( "#form_id-3664" )
    if( form_id_3664 ){

        let tokens = document.createElement( "input" )
        tokens.type = "hidden"
        tokens.name = "_access_token"

        form_id_3664.appendChild( tokens )

        let checks = document.querySelectorAll( ".field_3664_21 label" )
        
        checks.forEach( ( item, index ) => {

            item.addEventListener( "click", ( e ) => {

                let token_of_list = "";

                let value_checkbox = e.target.parentNode.querySelector( "input" ).value

                switch (value_checkbox) {
        
                    case 'special_offers__events_&_news':
                        token_of_list = 'a622c7df-64b1-44df-9088-16b1608a8228';
                        break;
                    case 'dining_&_culinary':
                        token_of_list = '9d1c0549-6627-44ac-9490-96be27d3a1d8';
                        break;
                    case 'aarna_spa_&_wellness':
                        token_of_list = '2f228744-90fb-49ad-9898-ff7de4a4e58e';
                        break;
                    case 'meetings_&_conferences':
                        token_of_list = '8542846c-68ee-4e7b-ac8a-d192a8fef781';
                        break;
                    case 'wedding_planning':
                        token_of_list = '1d0e5c51-1745-48a5-beb9-9356eb26ca61';
                        break;
                    case 'stay_golden_rewards':
                        token_of_list = '0903fd31-3c9f-47b0-81f3-d0d9cdf258f8,771bc769-bea4-40c8-b04e-cd031ea3e7d1'
                }

                let values = tokens.value

                if( values.indexOf( token_of_list ) != "-1" ){
                    values = values.replace( token_of_list + ",", "" )
                    tokens.value = values
                }else{
                    values += token_of_list + ","
                    tokens.value = values
                }

            } )

        } )

    }

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    /// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick({
        accessibility: true
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true
    });

    $('.images-slides figure').attr('aria-hidden', false);

    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.slider-bg-info').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });


    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        slidesToShow: 4,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 44;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},400);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
        $('.learn-more-btn').append('<div class="arrow"></div>');
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 44;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 44;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    let form_signup_lightbox = document.querySelector('#form-sign-up');
    if( form_signup_lightbox ){
        let allGroup = form_signup_lightbox.querySelectorAll('.form-module__group');
        let prev_group = document.querySelector('.js-back_group');
        let next_group = document.querySelector('.js-next_group');
        let div_progress_bar = document.querySelector('.js-progressbar');
        let stateNumberBar = 1;
        let stateProgressBar = 100 / allGroup.length;

        form_signup_lightbox.querySelector('.gdpr-wrap').classList.add('hidden');
        form_signup_lightbox.querySelector('.form-module__submit').classList.add('hidden');
        allGroup.forEach( ( eachGroup, i ) => {
            if( i > 0 ){
                eachGroup.classList.add('hidden');
            }
        } );

        div_progress_bar.querySelector('label').textContent = `${stateNumberBar}/${allGroup.length}`;

        prev_group.addEventListener('click', (e) => {
            e.preventDefault();
            let currentGroupActive = form_signup_lightbox.querySelector('.form-module__group:not(.hidden)');
            let prevGroupActive = currentGroupActive.previousElementSibling;
            if( prevGroupActive.classList.contains('form-module__group') ){
                currentGroupActive.classList.add('hidden');
                prevGroupActive.classList.remove('hidden')
                stateNumberBar--;
                stateProgressBar = stateProgressBar - 100 / allGroup.length == 0 ? 25 : stateProgressBar - 100 / allGroup.length;
                div_progress_bar.querySelector('label').textContent = `${stateNumberBar}/${allGroup.length}`;
                div_progress_bar.querySelector('progress').value = `${stateProgressBar}`;
                if( stateNumberBar == 1 ){
                    prev_group.classList.add('hidden')
                }

                if( stateNumberBar < allGroup.length ){
                    form_signup_lightbox.querySelector('.gdpr-wrap').classList.add('hidden');
                    form_signup_lightbox.querySelector('.form-module__submit').classList.add('hidden');
                    next_group.classList.remove('hidden');
                }
            }
        });

        next_group.addEventListener('click', (e) => {
            e.preventDefault();
            let currentGroupActive = form_signup_lightbox.querySelector('.form-module__group:not(.hidden)');
            let nextGroupActive = currentGroupActive.nextElementSibling;
            let conunterError = 0;

            currentGroupActive.querySelectorAll('input.required, textarea.required, select.required, checkbox.required').forEach( input => {
                if( input.value == '' || !input.value || input.value == ' ' ){
                    conunterError++;
                }
            } )

            if( conunterError == 0 ){
                if( nextGroupActive.classList.contains('form-module__group') ){
                    currentGroupActive.classList.add('hidden');
                    nextGroupActive.classList.remove('hidden');
                    stateNumberBar++;
                    stateProgressBar = stateProgressBar + 100 / allGroup.length;
                    div_progress_bar.querySelector('label').textContent = `${stateNumberBar}/${allGroup.length}`;
                    div_progress_bar.querySelector('progress').value = `${stateProgressBar}`;
                    if ( prev_group.classList.contains('hidden') ) {
                        prev_group.classList.remove('hidden');
                    }
                    if( document.querySelector('.fill_fields') ){
                        document.querySelector('.fill_fields').classList.add('hidden')
                    }
                    if( !nextGroupActive.nextElementSibling.classList.contains('form-module__group') ){
                        form_signup_lightbox.querySelector('.gdpr-wrap').classList.remove('hidden');
                        form_signup_lightbox.querySelector('.form-module__submit').classList.remove('hidden');
                        form_signup_lightbox.querySelector('.advice_to_requiered_fiels').classList.add('hidden');
                        next_group.classList.add('hidden');
                        
                    }
                }
            }else{
                if ( !document.querySelector('.fill_fields') ) {
                    form_signup_lightbox.insertAdjacentHTML( "beforeend", "<strong class='fill_fields'>Please fill all the fields Required *</strong>" );
                }
            }
            
        })
    }

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))").click(function(e){
        e.preventDefault();
        let strAncla = $(this).prop('hash').substr(1);
        animateto(strAncla);
    });

    let screenHeight = $(window).height();
    $('#home .top-img figure, #home .top-img video').css("height", screenHeight);

    $(window).resize(function(){
        screenHeight = $(window).height();
        $('#home .top-img figure, #home .top-img video').css("height", screenHeight);
    });

    $("input[name*=select_destination]").eq(0).attr("checked", "checked");


    // INPUT VALIDATIONS FORM 2710

    if(document.querySelector('#form_id-2710')){
        document.querySelector('#form_id-2710').innerHTML += '<div class="hidden"> <label>Stay Golden</label> <input class="long" type="text" name="STAYGOLDEN"/> </div> '
        document.querySelector('[name="STAYGOLDEN"]').value = 'Enrolled';
    }


    // Funtion to modify the sub-menu aria-label
    document.addEventListener('DOMContentLoaded', function(){
        const subMenu = document.querySelector('#subMenu nav.sub-menu'); 
        if(subMenu){
            subMenu.setAttribute('aria-label','Menus Navigation')
        }
    });

    const inputFirstNameField = document.querySelectorAll('.js-firstNameField2710 input');
    const inputLastNameField = document.querySelectorAll('.js-lastNameField2710 input');
    console.log(inputFirstNameField[0]);
    if(inputFirstNameField[0]){
        inputFirstNameField[0].addEventListener("keyup", function (event) {
            if (event.key.match(/[0-9]/)) {
                inputFirstNameField[0].value = '';
            }
        });
    }
    if(inputLastNameField[0]){
        inputLastNameField[0].addEventListener("keyup", function (event) {
            if (event.key.match(/[0-9]/)) {
                inputLastNameField[0].value = '';
            }
        });
    }

    const inputPostCodeField = document.querySelectorAll('.js-postalCodeField2710 input');
    if(inputPostCodeField[0]){
        inputPostCodeField[0].addEventListener("keydown", function () {
            const postcode = inputPostCodeField[0].value;
            if (postcode.length < 4) {
                const errorMgs = "<span>Please enter at least 5 characters.</span>";
                if (document.querySelectorAll('.js-postalCodeField2710 span').length < 1) {
                    inputPostCodeField[0].insertAdjacentHTML('afterend', errorMgs)
                }
                document.querySelector('.js-postalCodeField2710 span').classList.add('errorMsgForm');
            } else {
                const spanPostCodeField = document.querySelector('.js-postalCodeField2710 span');
                if (document.querySelector('.js-postalCodeField2710 span')) {
                    document.querySelector('.js-postalCodeField2710').removeChild(spanPostCodeField)
                }
            }
        });
    }

    const inputPhoneField = document.querySelectorAll('.js-phoneField2710 input');
    if(inputPhoneField[0]){
        inputPhoneField[0].setAttribute('onInput','this.value = phoneFormat(this.value)')
        inputPhoneField[0].addEventListener("keydown", function () {
            let phoneNumber = inputPhoneField[0].value.replace(/\D/g, "");
            if (phoneNumber.length < 9) {
                const errorMgs = "<span>Please enter a valid Day Phone.</span>";
                if (document.querySelectorAll('.js-phoneField2710 span').length < 1) {
                    inputPhoneField[0].insertAdjacentHTML('afterend', errorMgs)
                }
                document.querySelector('.js-phoneField2710 span').classList.add('errorMsgForm');
            } else {
                const spanPostCodeField = document.querySelector('.js-phoneField2710 span');
                if (document.querySelector('.js-phoneField2710 span')) {
                    document.querySelector('.js-phoneField2710').removeChild(spanPostCodeField)
                }
            }
        });
    }
   
    const inputDatePickerField = document.querySelectorAll('.js-datePickerField2710 input');
    if(inputDatePickerField[0]){
        inputDatePickerField[0].addEventListener('blur', function(event) {
            let oldValue = new Date(event.target.value);
            let selectedDate;
            
            const intervalo = setInterval(() => {
                selectedDate = new Date(event.target.value);
                if( event.target.value !== '' || event.target.value !== oldValue ){
                    clearInterval(intervalo);
                   
                    doValidation();
                }
            }, 1000);
    
    
            const doValidation = () => {
                const currentDate = new Date();
                const minAge = 21;
                const limitDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - minAge));
                
                const errorMgs = "<span>You must be older than 21 years.</span>";
                if (selectedDate <= limitDate) {
                    const spanDatePickerField = document.querySelector('.js-datePickerField2710 span');
                    document.querySelector('.js-datePickerField2710').removeChild(spanDatePickerField);
                }else{
                    if (document.querySelectorAll('.js-datePickerField2710 span').length < 1) {
                        inputDatePickerField[0].insertAdjacentHTML('afterend', errorMgs)
                    }
                    document.querySelector('.js-datePickerField2710 span').classList.add('errorMsgForm');
                    document.querySelector('.js-datePickerField2710 input').value = '';
                }
            }
            
    
           
        });
    }

    
    let contact_form = document.querySelector('#form_id-1351');
    if (contact_form){
        let select_contactForm = contact_form.querySelector('.js-subject_change select');
        select_contactForm.addEventListener('change', e => {
            contact_form.querySelector('[name="sendto"]').setAttribute(`value`, `${changeSendTo(select_contactForm.value)}`)

            function changeSendTo(value_optionSelected){ 
                switch (value_optionSelected) {
                    case 'reservations':
                            return 'reservations@paseahotel.com'
                        break;
                    case 'front_desk':
                            return 'frontdesk@paseahotel.com'
                        break;
                    case 'donations':
                        return 'reservations@paseahotel.com'
                        break;
                    case 'collaborations':
                        return 'reservations@paseahotel.com'
                        break;
                    case 'sales_&_travel_advisor_inquiries':
                        return 'sales@paseahotel.com'
                        break;
                    default:
                        return 'reservations@paseahotel.com'
                }
            }

        })
    }

    let form_id_3871 = document.querySelector( "input[name='form_id'][value='3871']" ); 
    if( form_id_3871 ){ 
        form_id_3871 = form_id_3871.parentElement; 

        let golden = document.createElement( "input" ) 
        golden.type = "hidden" 
        golden.name = "STAYGOLDEN" 
        golden.value = "Enrolled" 
        form_id_3871.appendChild( golden ) 
    }

    document.addEventListener('DOMContentLoaded', (event) => {
        
        let signUp_page_form = document.querySelector('#form_id-2970');
    
        if(signUp_page_form){
            let checkboxes = signUp_page_form.querySelectorAll('.form-module__field--unit input[type=checkbox]');

            checkboxes.forEach(checkbox => {
                checkbox.addEventListener( 'change', () => {
                    let _accesToken = signUp_page_form.querySelector('input[name="_access_token"]');
                    if(checkbox.checked){
                        console.log('checked');
                        _accesToken.value = updateAccesToken(_accesToken.value, checkbox.value);
                    }else{
                        console.log('no-checked');
                        _accesToken.value = updateAccesToken(_accesToken.value, checkbox.value);
                    }
                } )
            });
    
            function updateAccesToken(accesToken_value, value_checkbox){

                let arr_Values_Tokens = accesToken_value.split(','),
                    token_of_list = null;
    
                console.log( value_checkbox );

                switch (value_checkbox) {
    
                    case 'special_offers__events_&_news':
                        token_of_list = 'a53ec3f7-bd76-4637-a368-8fc6ec43a67d';
                        break;
                    case 'dining_&_culinary':
                        token_of_list = '9d1c0549-6627-44ac-9490-96be27d3a1d8';
                        break;
                    case 'aarna_spa_&_wellness':
                        token_of_list = '2f228744-90fb-49ad-9898-ff7de4a4e58e';
                        break;
                    case 'meetings_&_conferences':
                        token_of_list = '8542846c-68ee-4e7b-ac8a-d192a8fef781';
                        break;
                    case 'wedding_planning':
                        token_of_list = '1d0e5c51-1745-48a5-beb9-9356eb26ca61';
                        break;
                }

                if(arr_Values_Tokens.includes(token_of_list))
                    arr_Values_Tokens = arr_Values_Tokens.filter(token => token != token_of_list);
                else
                    arr_Values_Tokens.push(token_of_list)
    
                return arr_Values_Tokens.join(',')
    
            }
    
        }

    });
    
    // ====== UPDATE thank You Message on sign-up form
    // const urlSignUpBTN = 'https://www.paseahotel.com/stay-golden';

    // function createAnchorButton( url ){
    //     let button = document.createElement('a');
    //     button.setAttribute('href', url);
    //     button.setAttribute('class', 'btn btn-primary');
    //     button.textContent = 'Join TODAY';

    //     console.log(button);

    //     return button;
    // }

    // if(document.querySelector('.sign-up ')){
    //     let formMessage = document.querySelector('.sign-up .thankyouMsg');

    //     let newMessage = "Thank you for signing up.</br> <span>You're Invited!</span> </br>Earn More Every Stay with Stay Golden Rewards at any Meritage Collection property. With this membership, you gain privileged access to exclusive pricing, rewards to enhance your stay, special offers and more. Make your stay count by signing up for our Stay Golden Rewards program and save more. </br>"


    //     formMessage.innerHTML = newMessage;
    //     formMessage.append( createAnchorButton( urlSignUpBTN ) );
    // }
    // END =====  UPDATE thank You Message on sign-up form

})();


// FORMAT THE PHONENUMBER OF THE FORM 2710

function phoneFormat(input) {
    input = input.replace(/\D/g,'');
    var size = input.length;
    if (size>0) {input="("+input}
    if (size>3) {input=input.slice(0,4)+") "+input.slice(4,11)}
    if (size>6) {input=input.slice(0,9)+"-" +input.slice(9)}
    return input;
}

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}